import React, { useState, useEffect } from "react";
import MotoGame from "./MotoGame";
import { supabase } from "./supabaseClient";

function App() {
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [yaJugo, setYaJugo] = useState(false);
  const [nombreAsesor, setNombreAsesor] = useState("");

  useEffect(() => {
    // Obtener token de la URL (desde React Router)
    const path = window.location.pathname;
    const tokenUrl = path.split('/motos/')[1]; // Extraer token de /motos/TOKEN
    
    if (!tokenUrl) {
      setError("Token no válido o faltante");
      setLoading(false);
      return;
    }

    // Verificar token en la base de datos
    verificarToken(tokenUrl);
  }, []);

  const verificarToken = async (tokenUrl) => {
    try {
      console.log("🔍 Verificando token:", tokenUrl);
      
      const { data, error } = await supabase
        .from('tokens_navidad')
        .select('*')
        .eq('token', tokenUrl)
        .single();

      if (error || !data) {
        console.error("❌ Error al verificar token:", error);
        setError("Token inválido o expirado");
        setLoading(false);
        return;
      }

      console.log("✅ Token válido:", data);

      if (data.usado) {
        setYaJugo(true);
        setNombreAsesor(data.nombre_asesor);
        setError(`${data.nombre_asesor}, ya participaste. Tu premio fue: ${data.premio}`);
        setLoading(false);
        return;
      }

      setToken(data);
      setNombreAsesor(data.nombre_asesor);
      setLoading(false);
    } catch (err) {
      console.error("❌ Error:", err);
      setError("Error al verificar el token");
      setLoading(false);
    }
  };

  const guardarPremio = async (premioGanado) => {
    try {
      console.log("💾 Guardando premio:", premioGanado);
      
      const { error } = await supabase
        .from('tokens_navidad')
        .update({ 
          premio: premioGanado, 
          usado: true,
          fecha_juego: new Date().toISOString()
        })
        .eq('token', token.token);

      if (error) {
        console.error("❌ Error al guardar premio:", error);
      } else {
        console.log("✅ Premio guardado exitosamente:", premioGanado);
      }
    } catch (err) {
      console.error("❌ Error:", err);
    }
  };

  if (loading) {
    return (
      <div style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #0a0a0a 0%, #1a0f00 25%, #2d1400 50%, #1a0f00 75%, #0a0a0a 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        {/* Nieve de fondo */}
        {[...Array(30)].map((_, i) => (
          <div
            key={i}
            style={{
              position: "fixed",
              top: "-10px",
              left: `${Math.random() * 100}%`,
              width: "8px",
              height: "8px",
              background: "white",
              borderRadius: "50%",
              opacity: Math.random() * 0.6 + 0.3,
              animation: `snowfall ${Math.random() * 3 + 5}s linear infinite`,
              animationDelay: `${Math.random() * 5}s`,
              pointerEvents: "none"
            }}
          />
        ))}

        <style>{`
          @keyframes snowfall {
            to { transform: translateY(100vh); opacity: 0; }
          }
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>

        <div style={{ 
          textAlign: "center",
          position: "relative",
          zIndex: 2
        }}>
          <div style={{ 
            fontSize: "5rem", 
            marginBottom: "1rem",
            animation: "spin 2s linear infinite"
          }}>
            🏍️
          </div>
          <div style={{
            color: "#ff6a00",
            fontSize: "2rem",
            fontWeight: "bold",
            textShadow: "0 0 20px rgba(255, 106, 0, 0.8)"
          }}>
            Cargando juego...
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #0a0a0a 0%, #1a0f00 25%, #2d1400 50%, #1a0f00 75%, #0a0a0a 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        padding: "2rem",
        position: "relative",
        overflow: "hidden"
      }}>
        {/* Nieve de fondo */}
        {[...Array(30)].map((_, i) => (
          <div
            key={i}
            style={{
              position: "fixed",
              top: "-10px",
              left: `${Math.random() * 100}%`,
              width: "8px",
              height: "8px",
              background: "white",
              borderRadius: "50%",
              opacity: Math.random() * 0.6 + 0.3,
              animation: `snowfall ${Math.random() * 3 + 5}s linear infinite`,
              animationDelay: `${Math.random() * 5}s`,
              pointerEvents: "none"
            }}
          />
        ))}

        <style>{`
          @keyframes snowfall {
            to { transform: translateY(100vh); opacity: 0; }
          }
        `}</style>

        <div style={{
          background: "rgba(0, 0, 0, 0.9)",
          border: "3px solid #ff6a00",
          borderRadius: "20px",
          padding: "3rem",
          maxWidth: "500px",
          textAlign: "center",
          boxShadow: "0 0 40px rgba(255, 106, 0, 0.6)",
          position: "relative",
          zIndex: 2
        }}>
          <div style={{ 
            marginBottom: "1.5rem"
          }}>
            <img 
              src="https://invercycle.com/wp-content/uploads/2023/04/LOGOINVERCYCLE.png"
              alt="Invercycle"
              style={{
                maxWidth: "200px",
                height: "auto"
              }}
            />
          </div>
          <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>⚠️</div>
          <div style={{
            color: "#ff6a00",
            fontSize: "1.5rem",
            fontWeight: "bold",
            textShadow: "0 0 10px rgba(255, 106, 0, 0.8)",
            lineHeight: "1.5"
          }}>
            {error}
          </div>
        </div>
      </div>
    );
  }

  return (
    <MotoGame 
      onFinish={guardarPremio}
      disabled={yaJugo}
      nombreAsesor={nombreAsesor}
    />
  );
}

export default App;
  